module.exports = __webpack_public_path__ + "static/media/dong-wallet.52893863.png";